<template>
  <div class="sensor" :sensor="(text=='优'&& 'great') || (text=='良'&& 'good') || (text=='差'&& 'bad')">
    <div class="header">
      <div class="title">
        <span>{{$config.staticConfig.isNeed ? $config.staticConfig.titleList.sensor :'教室'}}环境综合指数</span>
        <span class="updata-time">{{lastTime ? lastTime + '前更新' : '暂无环境信息'}}</span>
      </div>
      <div class="score">
        <div v-text="kpi"></div>
        <div v-text="text"></div>
      </div>
      <div class="btn text-center" @click="autoExecute()" v-operating.click="'立即优化'">
        <span>立即优化</span>
      </div>
      <div class="suggest">
        <div v-html="suggest&&suggest[0]"></div>
      </div>
    </div>
    <div class="data">
      <div class="text-center">
        <div>
          <sensor-text text="温度" unit="℃" :value="sensor['DHTt'].value" :color="sensor['DHTt'].color"></sensor-text>
        </div>
        <div>
          <sensor-text text="PM2.5" unit="μg/m³" :value="sensor['PM25'].value"
                       :color="sensor['PM25'].color"></sensor-text>
        </div>
        <div>
          <sensor-text text="PM10" unit="μg/m³" :value="sensor['PM10'].value"
                       :color="sensor['PM10'].color"></sensor-text>
        </div>
        <div>
          <sensor-text text="CO2" unit="ppm" :value="sensor['CO2'].value" :color="sensor['CO2'].color"></sensor-text>
        </div>
      </div>
      <div class="text-center">
        <div>
          <sensor-text text="湿度" unit="%" :value="sensor['DHTh'].value" :color="sensor['DHTh'].color"></sensor-text>
        </div>
        <div>
          <sensor-text text="甲醛" unit="μg/m³" :value="sensor['CH2O'].value" :color="sensor['CH2O'].color"></sensor-text>
        </div>
        <div>
          <sensor-text text="TVOC" unit="μg/m³" :value="sensor['TVOC'].value"
                       :color="sensor['TVOC'].color"></sensor-text>
        </div>
        <div>
          <sensor-text text="亮度" unit="lux" :value="sensor['ALS'].value | brightnessFormula" :color="sensor['ALS'].color"></sensor-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SensorText from './SensorText'
import sensorKPI from '../assets/lib/sensorKPI'
import { Message } from 'element-ui'
import api from '../model/device'
export default {
  name: 'Sensor',
  data () {
    return {
      sensorQuota: {
        DHTt: {
          icon: 'icon-wendu',
          unit: '℃',
          desc: '温度',
          range: [
            { min: 0, max: 5, color: '#B007B7', text: '寒冷' },
            { min: 6, max: 9, color: '#F5A623', text: '冷' },
            { min: 10, max: 17, color: '#f7da64', text: '凉爽' },
            { min: 18, max: 27, color: '#4CD964', text: '舒适' },
            { min: 28, max: 29, color: '#f7da64', text: '温热' },
            { min: 30, max: 100, color: '#B007B7', text: '炎热' }
          ],
          out: true
        },
        DHTh: {
          icon: 'icon-shidu',
          unit: '%',
          desc: '湿度',
          range: [
            { min: 39, max: 70, color: '#4CD964', text: '舒适' },
            { min: 71, max: 85, color: '#f7da64', text: '湿润' },
            { min: 16, max: 38, color: '#f7da64', text: '干燥' },
            { min: 86, max: 100, color: '#F5A623', text: '潮湿' },
            { min: 0, max: 15, color: '#B007B7', text: '干燥' }],
          out: true
        },
        PM25: {
          icon: 'icon-sensor-PM25',
          unit: 'μg/m³',
          desc: 'PM25',
          range: [
            { min: 0, max: 35, color: '#4CD964', text: '优' },
            { min: 36, max: 100, color: '#f7da64', text: '良' },
            { min: 101, max: 150, color: '#F5A623', text: '轻度' },
            { min: 151, max: 200, color: '#B007B7', text: '中度' },
            { min: 201, max: 5000, color: '#9E004F', text: '重度' }
          ],
          out: true
        },
        PM10: {
          icon: 'icon-PM',
          unit: 'μg/m³',
          desc: 'PM10',
          range: [
            { min: 0, max: 35, color: '#4CD964', text: '优' },
            { min: 36, max: 100, color: '#f7da64', text: '良' },
            { min: 101, max: 150, color: '#F5A623', text: '轻度' },
            { min: 151, max: 200, color: '#B007B7', text: '中度' },
            { min: 201, max: 5000, color: '#9E004F', text: '重度' }
          ],
          out: true
        },
        CH2O: {
          icon: 'icon-wendu',
          unit: 'μg/m³',
          desc: '甲醛',
          range: [{ min: 0, max: 80, color: '#4CD964', text: '优' },
            { min: 80, max: 50000, color: '#B007B7', text: '差' }]
        },
        TVOC: {
          icon: 'icon-wendu',
          unit: 'μg/m³',
          desc: 'TVOC',
          range: [{ min: 0, max: 500, color: '#4CD964', text: '优' },
            { min: 501, max: 10000, color: '#B007B7', text: '差' }]
        },
        CO2: {
          icon: 'icon-wendu',
          unit: 'ppm',
          desc: 'CO2',
          range: [{ min: 0, max: 1000, color: '#4CD964', text: '优' },
            { min: 1001, max: 2000, color: '#F5A623', text: '良' },
            { min: 2001, max: 10000, color: '#B007B7', text: '差' }]
        },
        ALS: {
          icon: 'icon-wendu',
          unit: '%',
          desc: '亮度',
          range: [{ min: 75, max: 100, color: '#4CD964', text: '优' },
            { min: 60, max: 74, color: '#F5A623', text: '良' },
            { min: 0, max: 59, color: '#B007B7', text: '差' }]
        }
      },
      suggestCommand: {
        airpure: ['室内二氧化碳含量较高，建议开启新风', '室内甲醛含量较高，建议开启新风', '室内PM2.5含量较高，建议开启新风'],
        light: ['室内较为昏暗，建议开灯或提高灯具亮度'],
        aircon: ['温度较低，请打开空调制热', '温度较高，请打开空调制冷'],
        humidifier: ['环境较为干燥，建议打开加湿设备']
      }
    }
  },
  components: {
    SensorText
  },
  computed: {
    sensor () {
      return this.$store.getters.sensorState(this.sensorQuota)
    },
    kpi () {
      return this.$store.state.sensor && parseInt(sensorKPI.getKPI(this.$store.state.sensor))
    },
    text () {
      if (this.kpi >= 85) {
        return this.$store.state.sensor && '优'
      } else if (this.kpi >= 60) {
        return this.$store.state.sensor && '良'
      } else {
        return this.$store.state.sensor && '差'
      }
    },
    suggest () {
      return sensorKPI.getSuggest(this.$store.state.sensor)
    },
    lastTime () {
      let time = 0
      if (this.$store.state.sensorTime) {
        let current = Math.abs(new Date().getTime() - new Date(this.$store.state.sensorTime).getTime())
        let days = current / 1000 / 60 / 60 / 24
        let daysRound = Math.floor(days)
        let hours = current / 1000 / 60 / 60 - (24 * daysRound)
        let hoursRound = Math.floor(hours)
        let minutes = current / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound)
        let minutesRound = Math.floor(minutes)
        time = daysRound ? `${daysRound}天` : hoursRound ? `${hoursRound}小时` : minutesRound ? `${minutesRound}分钟` : '当'
      }
      return time
    }
  },
  methods: {
    async autoExecute () {
      // 此处需要执行的是，自动化优化动作，流程如下 1、确保要执行的设备存在，如果不存在提示   2、执行的时候需要根据内容进行判断   3、提示仅1条，但是执行可能是多个（因为显示区域有限）
      if (this.suggest && this.suggest[0] === '室内环境舒适') {
        Message.success('环境舒适，无需进行优化')
      } else {
        // 开始进行数据解析，先解析出设备及动作，在进行check，最好进行控制
        const command = []
        this.suggest.forEach(s => {
          for (const key in this.suggestCommand) {
            if (this.suggestCommand[key].indexOf(s) > -1) {
              // 找到设备了
              const exist = command.filter(d => d.type === key)
              if (!exist.length) {
                command.push({ type: key, state: 1 })
                if (key === 'light') {
                  command.push({ type: key, br: 90 })
                } else if (key === 'aircon') {
                  command.push({ type: key, mode: s.indexOf('较低') > -1 ? 1 : 0 })
                }
              }
            }
          }
        })
        // 开始执行
        for (const c of command) {
          try {
            await api.batchControl([c.type], c.state ? 'open' : c.br ? 'br' : c.mode === 0 ? 'cool' : 'warm', c.br ? c.br : null)
          } catch (e) {
            Message.error(e.message)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/less/base";

.sensor[sensor=great] {
  background: url("../assets/images/home/sensor-great.png") no-repeat center;
  background-size: cover;
  .header {
    .btn > span {
      color: #32D374;
    }
  }
}

.sensor[sensor=bad] {
  background: url("../assets/images/home/sensor-bad.png") no-repeat center;
  background-size: cover;
  .header {
    button {
      color: #E7787E;
    }
  }
}

.sensor, .sensor[sensor=good] {
  background: url("../assets/images/home/sensor-good.png") no-repeat center;
  border-radius: 6px;
  background-size: cover;
  .full-h;
  max-height: 530px;
  display: flex;
  flex-direction: column;
  > .header, .header[sensor=good] {
    padding: 18px 15px;
    height: 215px;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      display: flex;
      flex-flow: space-between nowrap;
      justify-content: space-between;
      .updata-time {
       font-size: 12px;
       margin-top: 1px;
       font-weight: 400;
      }
    }
    > .score {
      display: flex;
      justify-content: center;
      margin-top: 5px;
      vertical-align: top;
      > div:first-child {
        font-size: 60px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
      > div:last-child {
        font-size: 15px;
        font-weight: 600;
        padding-top: 15px;
        color: rgba(255, 255, 255, 1);
      }
    }
    .btn > span {
      cursor: pointer;
      display: inline-block;
      margin-top: -10px;
      border: 0;
      padding: 6px 15px;
      background: rgba(255, 255, 255, 1);
      border-radius: 14px;
      color: rgba(199, 162, 126, 1);
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 2px;
    }
    > .suggest {
      margin-top: 10px;
      .text-center;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      > div {
        max-width: 100%;
      }
    }
  }
  > .data {
    width: 100%;
    padding: 26px 15px;
    display: flex;
    justify-content: space-between;
    flex: 1;
    > div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    > div:first-child {
      flex: 1.05;
      width: 0;
    }
    > div:last-child {
      flex: 1;
      width: 0;
    }
  }
}
</style>
